module.exports = __webpack_public_path__ + "static/banner_small-f5937148e5129cb71f5cacd0fe95e3f9.png";